import {withTranslation} from "react-i18next";
import {
    Image, Page, StyleSheet, Font, Text, View,
} from "@react-pdf/renderer";
import 'moment/locale/es';
import source1Font from "../../../../assets/fonts/futura-book.otf";
import source2Font from "../../../../assets/fonts/futura-medium.woff";
import source3Font from "../../../../assets/fonts/futura-bold.woff";
import _ from "lodash";
import CardStudentPdf from "../datospersonales.pdf";
import PiePdf from "../pie.pdf";
import HeaderPdf from "../header.pdf";

Font.register({
    family: 'Futura',
    fonts: [{src: source1Font}, {src: source2Font, fontWeight: 500}, {src: source3Font, fontWeight: 700},]
});
Font.registerHyphenationCallback(word => [word]);
const layout = {
    labelCol: {
        span: 8,
    }, wrapperCol: {
        span: 16,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 8, span: 16,
    },
};
const styles = StyleSheet.create({
    page: {
        paddingBottom: 45, backgroundColor: "#ffffff",
    }, pageRes: {
        paddingBottom: 45, backgroundColor: "#ffffff",
    }, headerSection: {
        flexDirection: "row",
    }, table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
    }, tableRow: {margin: "auto", flexDirection: "row"}, tableCol: {
        width: "50%", borderStyle: "solid", borderWidth: 1, borderLeftWidth: 0, borderTopWidth: 0,
    }, tableCell: {
        margin: "auto", marginTop: 8, marginBottom: 8, fontSize: 10
    },
});

const stylesPdf = StyleSheet.create({
    page: {
        backgroundColor: 'white', fontFamily: 'Futura', fontSize: 14
    }, titleOne: {
        color: '#1C2E36', textAlign: 'center', marginTop: 12, fontSize: 16, fontWeight: 700, lineHeight: "175%"
    }, subtitle: {
        color: '#1C2E36', textAlign: 'center', fontSize: 16, fontWeight: 400
    }, spacetext: {
        marginTop: 8, marginBottom: 0
    }, spacetextxs: {
        marginTop: 4, marginBottom: 0
    }, step: {
        color: '#1C2E36',
        textAlign: 'justify',
        marginTop: 8,
        marginLeft: 24,
        marginRight: 24,
        fontSize: 12,
        fontWeight: 400,
        lineHeight: 1.5
    }, headerTable: {
        marginTop: 16,
        marginLeft: 24,
        marginRight: 24,
        padding: 8,
        backgroundColor: "#FFB81C",
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        borderColor: "#a5adbb",
        borderTopWidth: 1,
        borderRightWidth: 1,
        borderLeftWidth: 1,
    }, h1HeaderTable: {
        fontSize: 12,
        fontWeight: 500,
        color: "#1C2E36",
        textAlign: "left",
        lineHeight: "167%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    }, columnWidth60: {
        width: "60%",
    }, columnWidth40: {
        width: "40%",
    }, rowheadercolor: {
        display: "table",
        width: "auto",
        marginRight: 8,
        marginLeft: 8,
        borderWidth: 1,
        borderColor: "#FFB81C",
        padding: 0,
        borderTopRightRadius: 30,
        borderTopLeftRadius: 30
    },

    rowheader: {
        display: "table", width: "auto", borderWidth: 0, marginRight: 8, marginLeft: 8
    }, rowTable: {
        marginLeft: 24,
        marginRight: 24,
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderColor: "#a5adbb",
        borderBottomWidth: 1,
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderBottomRightRadius: 8,
        borderBottomLeftRadius: 8
    }, colTable: {
        width: "50%",
        padding: 8,
        backgroundColor: "#ffffff",
        fontSize: 12,
        marginLeft: 0,
        color: "#1C2E36",
        textAlign: "left",
        lineHeight: 1,
        borderStyle: "solid",
        borderColor: "#a5adbb",
        borderTopWidth: 1
    }, colTableBottomL: {
        borderBottomLeftRadius: 8,
    }, colTableBottomR: {
        borderBottomRightRadius: 8
    }, colBorderCenter: {
        borderLeftWidth: 1, borderColor: "#a5adbb"
    },  footer: {
        margin: 16,
        fontSize: 9,
        textAlign: "center",
        position: 'absolute',
        bottom: 30,
        left: 0,
        right: 0,
    }, footerFirstPage: {
        marginTop: 16, marginRight: 16, marginBottom: 56, marginLeft: 16, fontSize: 9, textAlign: "center"
    }, imagelogoheader: {
        width: 90,
    }, imageLogoCenter: {
        width: 172, marginBottom: 16
    }, imageReportCenter: {
        width: 154, height: 154, marginBottom: 24
    }, titlePortada: {
        fontSize: 20, marginBottom: 8
    }, subtitlePortada: {
        fontSize: 20, fontWeight: 700, textTransform: "uppercase"
    }, numberPage: {
        position: 'absolute', bottom: 24, right: 24, textAlign: 'right', color: '#1C2E36', fontSize: 10
    }, link: {
        color: "#20388f"
    }, pageBackground: {
        position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, zIndex: 0,
    }, pageBackgroundFooter: {
        position: 'absolute', right: 0, bottom: 0, left: 0, zIndex: 0, height: 40
    }, lineText: {
        display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center"
    }, lineText2: {

        display: "flex", flexDirection: "row",
    },

    strongText: {
        fontWeight: 500
    }, strongText2: {
        fontSize: 11, fontWeight: 500
    }, strongText3: {
        fontSize: 14, fontWeight: 500
    }, paddingTextCenter: {
        paddingTop: 6, fontSize: 11
    }, marginT4: {
        marginTop: 4
    }
});
function TekPartPdf(props) {

    const { t,

        i18n,
        studentProfile, answers,studentArea,timeline,levels,answersCervo,studentHistory,
        answersNoGame3,answersNoGame4,answersNoGame5,answersNoGame6,getStudentArea,studentAreaCervo, course} = props;



    const getResponse = (array, code) => {
        let mResult = _.filter(array, function (o) {
            return o.assessment && o.assessment.order === code
        });

        if (mResult && mResult.length > 0) {

            if (mResult[0].points === 99 || mResult[0].points === 999){
                return "";
            }else {
                if (mResult[0].assessment.questionType === "RATING") {

                    return mResult[0].points
                } else if (mResult[0].assessment.questionType === "RATINGOB") {

                    return mResult[0].yesno === 1 ? t("yes") + ". " + mResult[0].points : t("no")
                } else if (mResult[0].assessment.questionType === "MULTIPLE3" || mResult[0].assessment.questionType === "MULTIPLE2" || mResult[0].assessment.questionType === "MULTIPLE4") {
                    let mText = mResult[0].subanswers.map(sub => sub.response.question).join(', ')

                    return mText
                } else {
                    if (mResult[0].response) {
                        return mResult[0]?.response?.question
                    } else {
                        if (mResult[0].degree) {
                            return mResult[0]?.degree?.family + " " + mResult[0]?.degree?.title
                        }
                    }
                }
            }
            return "";

        } else {
            return ""
        }

    }


    return <>

        {/* PRIMERA PAGINA */}

        <HeaderPdf t={t} stylesPdf={stylesPdf} styles={styles} titlepdf={t("informes.titlepdf")} subtitle={t("informes.teksubtitle")} />
        {/* SEGUNDA PAGINA */}
        <Page size="A4" style={stylesPdf.page}>
            <Image src="/assets/img/backgroundpdf.png" style={stylesPdf.pageBackground} fixed/>
            <View style={stylesPdf.rowheader}>
                <View style={{flexDirection: "row"}}>
                    <View style={{width: "100%", textAlign: "left", marginLeft: 24, marginTop: 24}}>
                        <Image style={stylesPdf.imagelogoheader} src="/assets/img/logo.png"/>
                    </View>
                    <View style={{flexDirection: "row"}}>
                        <View style={{width: 100, textAlign: "right", marginRight: 24, marginTop: 24}}>
                            <Image style={styles.imagelogoheader} src="/assets/img/logoblanco.png"/>
                        </View>
                    </View>
                </View>

                <View style={{flexDirection: "row"}}>
                    <View style={{width: "100%", textAlign: "center", marginLeft: 24, marginTop: 10}}>
                        <Text style={stylesPdf.paddingTextCenter}>{t("informes.tuinformep")}</Text>
                    </View>
                </View>

                <View style={{flexDirection: "row"}}>
                    <View style={{width: "100%", textAlign: "center", marginLeft: 24, marginTop: 10}}>
                        <Text style={stylesPdf.strongText3}>{t("informes.teksubtitle")}</Text>
                    </View>
                </View>

                <CardStudentPdf  studentHistory={studentHistory}  year={(answers && answers[0] && answers[0].year) ?? 22} t={t} stylesPdf={stylesPdf} studentProfile={studentProfile}/>

                <View style={stylesPdf.rowheader}>
                    <View style={{marginTop: 24, flexDirection: "row",backgroundColor: "#FFB81C", borderTopLeftRadius: 30, borderTopRightRadius: 30}}>
                        <View style={{width: "100%",textAlign: "left", paddingLeft: 10, paddingTop: 5, paddingBottom: 5}}>

                            <Text style={stylesPdf.h1HeaderTable}>{t("informes.preferente")}: </Text>
                        </View>
                    </View>
                    <View style={{flexDirection: "row",
                        borderBottom: 1, borderBottomColor: '#FAFAFA',
                        borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                        <View style={{width: "40%", backgroundColor: '#FFFFFF', textAlign: "left", paddingLeft: 24, paddingTop: 12}}>
                            <View style={stylesPdf.lineText}>

                                {studentArea &&
                                    <Image  style={{height: 49}} src={`/assets/img/${studentArea.area.image}`}/>
                                }
                            </View>
                        </View>
                        <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 12}}>
                            <View style={stylesPdf.lineText}>
                                {studentArea && studentArea.area ?
                                    <Text style={stylesPdf.paddingTextCenter}>{studentArea?.area?.name}</Text>
                                    :
                                    <Text
                                        style={stylesPdf.paddingTextCenter}>{t("informes.pendiente.refvocacional").replace("<em>","").replace("</em>","")}</Text>
                                }


                            </View>
                        </View>
                    </View>
                </View>
                <View style={stylesPdf.rowheader}>
                    <View style={{width: "80%", textAlign: "left", marginLeft: 24, marginTop: 24}}>
                        <View style={stylesPdf.lineText}>
                            <Text style={stylesPdf.strongText2}>{t("informes.comenta")}</Text>
                        </View>

                    </View>
                </View>
            </View>
            <View fixed style={stylesPdf.footer}>
                <Text fixed>{t("contrato.footer")}</Text><Text>{t("contrato.subfooter")}</Text>
            </View>
        </Page>

        {/* TERCERA PAGINA */}
        <Page size="A4" style={stylesPdf.page}>
            <Image src="/assets/img/backgroundpdf.png" style={stylesPdf.pageBackground} fixed/>
            <View style={stylesPdf.rowheader}>
                <View style={{flexDirection: "row"}}>
                    <View style={{width: "100%", textAlign: "left", marginLeft: 24, marginTop: 24}}>
                        <Image style={stylesPdf.imagelogoheader} src="/assets/img/logo.png"/>
                    </View>
                    <View style={{flexDirection: "row"}}>
                        <View style={{width: 100, textAlign: "right", marginRight: 24, marginTop: 24}}>
                            <Image style={styles.imagelogoheader} src="/assets/img/logoblanco.png"/>
                        </View>
                    </View>
                </View>

                <View style={{flexDirection: "row"}}>
                    <View style={{width: "100%", textAlign: "center", marginLeft: 24, marginTop: 10}}>
                        <Text style={stylesPdf.paddingTextCenter}>{t("informes.tuinformep")}</Text>
                    </View>
                </View>

                <View style={{flexDirection: "row"}}>
                    <View style={{width: "100%", textAlign: "center", marginLeft: 24, marginTop: 10}}>
                        <Text style={stylesPdf.strongText3}>{t("informes.teksubtitle")}</Text>
                    </View>
                </View>

                <View style={{marginTop: 5, flexDirection: "row",backgroundColor: "#FFB81C", borderTopLeftRadius: 30, borderTopRightRadius: 30}}>
                    <View style={{width: "100%",textAlign: "left", paddingLeft: 10, paddingTop: 5, paddingBottom: 5}}>

                        <Text style={stylesPdf.h1HeaderTable}>{t("informes.miproyecto")} {course}</Text>
                    </View>
                </View>


                <View style={stylesPdf.rowheader}>
                    {timeline && timeline.length > 0 && timeline.map(item => {
                        return   <View style={{flexDirection: "row",
                            borderBottom: 1, borderBottomColor: '#FAFAFA',
                            borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                            <View style={{width: "20%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                                <View style={stylesPdf.lineText}>
                                    <Text style={stylesPdf.strongText2}>{item.date}</Text>
                                </View>
                            </View>
                            <View style={{width: "80%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                                <View style={stylesPdf.lineText}>
                                    <Text style={stylesPdf.paddingTextCenter}>{item.message.replace(/<strong>/g, "")
                                        .replace(/<\/strong>/g, "").replace(/<br ?\/?><br ?\/?>/g, "\n").replace(/<br ?\/?>/g, "\n")}</Text>
                                </View>
                            </View>
                        </View>
                    })
                    }

                </View>

                <View style={{marginTop: 5, flexDirection: "row",backgroundColor: "#FFB81C", borderTopLeftRadius: 30, borderTopRightRadius: 30}}>
                    <View style={{width: "100%",textAlign: "left", paddingLeft: 10, paddingTop: 5, paddingBottom: 5}}>

                        <Text style={stylesPdf.h1HeaderTable}>{t("informes.ceibatusrespuestas")}</Text>
                    </View>
                </View>


                <View style={stylesPdf.rowheader}>
                    {levels && levels.map(item => {
                        return (
                            <View key={item.id} style={{flexDirection: "row",
                                padding: 3,
                                borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                                <View style={{width: "95%",  display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center"}}>

                                    <View style={stylesPdf.lineText}>
                                        {item.points !== 99 && item.points !== -100 ?
                                            <Text style={{
                                                borderBottomRightRadius: 18,
                                                borderTopRightRadius: 18,
                                                minWidth: 172,
                                                fontStyle: 'normal',
                                                fontWeight: 400,
                                                fontSize: 10,
                                                paddingLeft: 10,
                                                color: "#1C2E36",
                                                width: `${(item.points === 999 ? 0 : 9 * item.points)}%`,
                                                backgroundColor:
                                                    item.points >= 0 && item.points < 5 ? "#FFA39E" :
                                                        item.points >= 5 && item.points < 8 ? "#FFD857" :
                                                            item.points === 999 ? "" : "#95DE64"
                                            }}>{item.name}</Text>
                                            :
                                            <Text>{item.points !== -100 &&
                                                t("indeciso")}</Text>
                                        }

                                        {item.points !== 99 && <Text
                                            style={stylesPdf.strongText2}>{(item.points)===-100 ? `${t("informes.pendiente.general")} ${item.qName}` : item.points === 999 ? t('indeciso') : item.points}</Text>}

                                    </View>
                                </View>
                            </View>)

                    })}
                    <View  style={{flexDirection: "row",
                        padding: 3,
                        borderBottom: 1, borderBottomColor: '#FAFAFA',
                        borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}></View>
                </View>

                <View style={stylesPdf.rowheader}>


                </View>
            </View>
            <View fixed style={stylesPdf.footer}>
                <Text>{t("contrato.footer")}</Text><Text>{t("contrato.subfooter")}</Text>
            </View>
        </Page>



        {/* CUARTA PAGINA */}
        <Page size="A4" style={stylesPdf.page}>
            <Image src="/assets/img/backgroundpdf.png" style={stylesPdf.pageBackground} fixed/>
            <View style={stylesPdf.rowheader}>
                <View style={{flexDirection: "row"}}>
                    <View style={{width: "100%", textAlign: "left", marginLeft: 24, marginTop: 24}}>
                        <Image style={stylesPdf.imagelogoheader} src="/assets/img/logo.png"/>
                    </View>
                    <View style={{flexDirection: "row"}}>
                        <View style={{width: 100, textAlign: "right", marginRight: 24, marginTop: 24}}>
                            <Image style={styles.imagelogoheader} src="/assets/img/logoblanco.png"/>
                        </View>
                    </View>
                </View>

                <View style={{flexDirection: "row"}}>
                    <View style={{width: "100%", textAlign: "center", marginLeft: 24, marginTop: 10}}>
                        <Text style={stylesPdf.paddingTextCenter}>{t("informes.tuinformep")}</Text>
                    </View>
                </View>

                <View style={{flexDirection: "row"}}>
                    <View style={{width: "100%", textAlign: "center", marginLeft: 24, marginTop: 10}}>
                        <Text style={stylesPdf.strongText3}>{t("informes.teksubtitle")}</Text>
                    </View>
                </View>

                <View style={{marginTop: 5, flexDirection: "row",backgroundColor: "#FFB81C", borderTopLeftRadius: 30, borderTopRightRadius: 30}}>
                    <View style={{width: "100%",textAlign: "left", paddingLeft: 10, paddingTop: 5, paddingBottom: 5}}>

                        <Text style={stylesPdf.h1HeaderTable}>{t("informes.turespuestas")}</Text>
                    </View>
                </View>





                <View style={stylesPdf.rowheader}>
                    <View style={{flexDirection: "row",
                        borderBottom: 1, borderBottomColor: '#FAFAFA',
                        borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                        <View style={{width: "40%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                            <View style={stylesPdf.lineText}>
                                <Text style={stylesPdf.strongText2}>{t("informes.respuestas.respuesta2")}</Text>
                            </View>
                        </View>
                        <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                            <View style={stylesPdf.lineText}>
                                {answersCervo && answersCervo.length > 0 ?
                                    <Text
                                        style={stylesPdf.paddingTextCenter}>{studentAreaCervo && studentAreaCervo.area.like}</Text>
                                    :
                                    <Text
                                        style={stylesPdf.paddingTextCenter}>{t("informes.pendiente.valvocacional").replace("<em>","").replace("</em>","")}</Text>
                                }
                            </View>
                        </View>
                    </View>



                </View>

                <View style={stylesPdf.rowheader}>
                    <View style={{flexDirection: "row",
                        borderBottom: 1, borderBottomColor: '#FAFAFA',
                        borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                        <View style={{width: "40%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                            <View style={stylesPdf.lineText}>
                                <Text style={stylesPdf.strongText2}>{t("informes.respuestas.respuesta61")}</Text>
                            </View>
                        </View>
                        <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                            <View style={stylesPdf.lineText}>
                                {answersNoGame3 && answersNoGame3.length > 0 &&  getResponse(answersNoGame3, 19)!== ""?
                                    <Text
                                        style={stylesPdf.paddingTextCenter}>{getResponse(answersNoGame3, 19)}</Text>
                                    :
                                    <Text
                                        style={stylesPdf.paddingTextCenter}>{t("informes.pendiente.reflexion").replace("<em>","").replace("</em>","")}</Text>
                                }
                            </View>
                        </View>
                    </View>



                </View>

                <View style={stylesPdf.rowheader}>
                    <View style={{flexDirection: "row",
                        borderBottom: 1, borderBottomColor: '#FAFAFA',
                        borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                        <View style={{width: "40%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                            <View style={stylesPdf.lineText}>
                                <Text style={stylesPdf.strongText2}>{t("informes.respuestas.respuesta62")}: </Text>
                            </View>
                        </View>
                        <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                            <View style={stylesPdf.lineText}>
                                {answersNoGame5 && answersNoGame5.length > 0 ?
                                    <Text
                                        style={stylesPdf.paddingTextCenter}>{getResponse(answersNoGame5, 6)}</Text>
                                    :
                                    <Text
                                        style={stylesPdf.paddingTextCenter}>{t("informes.pendiente.mihsitorial").replace("<em>","").replace("</em>","")}</Text>
                                }
                            </View>
                        </View>
                    </View>



                </View>


                <View style={stylesPdf.rowheader}>
                    <View style={{flexDirection: "row",
                        borderBottom: 1, borderBottomColor: '#FAFAFA',
                        borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                        <View style={{width: "40%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                            <View style={stylesPdf.lineText}>
                                <Text style={stylesPdf.strongText2}>{t("informes.respuestas.respuesta63")}: </Text>
                            </View>
                        </View>
                        <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                            <View style={stylesPdf.lineText}>
                                {answersNoGame5 && answersNoGame5.length > 0 ?
                                    <Text
                                        style={stylesPdf.paddingTextCenter}>{getResponse(answersNoGame5, 7)}</Text>
                                    :
                                    <Text
                                        style={stylesPdf.paddingTextCenter}>{t("informes.pendiente.mihsitorial").replace("<em>","").replace("</em>","")}</Text>
                                }
                            </View>
                        </View>
                    </View>



                </View>



                <View style={stylesPdf.rowheader}>
                    <View style={{flexDirection: "row",
                        borderBottom: 1, borderBottomColor: '#FAFAFA',
                        borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                        <View style={{width: "40%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                            <View style={stylesPdf.lineText}>
                                <Text style={stylesPdf.strongText2}>{t("informes.respuestas.respuesta64")}: </Text>
                            </View>
                        </View>
                        <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                            <View style={stylesPdf.lineText}>
                                {answersNoGame5 && answersNoGame5.length > 0 ?
                                    <Text
                                        style={stylesPdf.paddingTextCenter}>{getResponse(answersNoGame5, 11)}</Text>
                                    :
                                    <Text
                                        style={stylesPdf.paddingTextCenter}>{t("informes.pendiente.mihsitorial").replace("<em>","").replace("</em>","")}</Text>
                                }
                            </View>
                        </View>
                    </View>



                </View>







                <View style={stylesPdf.rowheader}>
                    <View style={{flexDirection: "row",
                        borderBottom: 1, borderBottomColor: '#FAFAFA',
                        borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                        <View style={{width: "40%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                            <View style={stylesPdf.lineText}>
                                <Text style={stylesPdf.strongText2}>{t("informes.respuestas.respuesta65")}: </Text>
                            </View>
                        </View>
                        <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                            <View style={stylesPdf.lineText}>
                                {answersNoGame6 && answersNoGame6.length > 0 ?
                                    <Text
                                        style={stylesPdf.paddingTextCenter}>{getResponse(answersNoGame6, 5)}</Text>
                                    :
                                    <Text
                                        style={stylesPdf.paddingTextCenter}>{t("informes.pendiente.micontexto").replace("<em>","").replace("</em>","")}</Text>
                                }
                            </View>
                        </View>
                    </View>



                </View>




                <View style={stylesPdf.rowheader}>
                    <View style={{flexDirection: "row",
                        borderBottom: 1, borderBottomColor: '#FAFAFA',
                        borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                        <View style={{width: "40%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                            <View style={stylesPdf.lineText}>
                                <Text style={stylesPdf.strongText2}>{t("informes.respuestas.respuesta66")}: </Text>
                            </View>
                        </View>
                        <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                            <View style={stylesPdf.lineText}>
                                {answersNoGame4 && answersNoGame4.length > 0 ?
                                    <Text
                                        style={stylesPdf.paddingTextCenter}>{getResponse(answersNoGame4, 14)}</Text>
                                    :
                                    <Text
                                        style={stylesPdf.paddingTextCenter}>{t("informes.pendiente.mibienestar").replace("<em>","").replace("</em>","")}</Text>
                                }
                            </View>
                        </View>
                    </View>

                </View>


            </View>
            <View fixed style={stylesPdf.footer}>
                <Text>{t("contrato.footer")}</Text><Text>{t("contrato.subfooter")}</Text>
            </View>
        </Page>

        <PiePdf t={t} stylesPdf={stylesPdf} styles={styles} />
    </>

}

export default withTranslation()(TekPartPdf);
